//import { isAuthenticated } from "./services/auth";
import ReactDOM from 'react-dom';
import eye from "../assets/imagens/olho.png";
import eyeClosed from "../assets/imagens/olho-fechado.png";
import aesjs from "aes-js";
import { useEffect, useState } from 'react';

export const toggleNav = async (id, classe) => {
    //alert('teste')
    const m = document.getElementById("sidebar");       
    let e = document.getElementById(id);
    let p = document.getElementById("padder");
    let f = document.getElementById("footer");

    if (e) {
        if (e.classList.contains(classe)) {
            e.classList.remove(classe);
            p.classList.remove(classe);
            m.classList.add("uk-left-menu-active");
            m.classList.remove("uk-left-menu-inative");
            p.classList.add("content-padder-active");
            p.classList.remove("content-padder-inative");
            f.classList.add("content-padder-active");
            f.classList.remove("content-padder-inative");
            return true;//Classe existia
        } else {
            e.classList.add(classe);
            m.classList.remove("uk-left-menu-active");
            m.classList.add("uk-left-menu-inative");
            p.classList.remove("content-padder-active");
            p.classList.add("content-padder-inative");
            f.classList.add("content-padder-inative");
            f.classList.remove("content-padder-active");
            return false;//Classe não existia
        }
    } else {
        return -1;
    }
};

export const toggleClasse = async (id, classe) => {   
    let e = document.getElementById(id);

    if (e) {
        if (e.classList.contains(classe)) {
            e.classList.remove(classe);
            return true;//Classe existia
        } else {
            e.classList.add(classe);
            return false;//Classe não existia
        }
    } else {
        return -1;
    }
};

export const DivActive = (id)=>{
    let c = document.getElementsByClassName("active")
    if(c?.[0]?.classList){
        c[0].classList.remove("active")
    }
    
    let element = document.getElementById(id) 
    element.classList.add("active")
};

export const visible = async (id) => {
    if (id) {
        var x = document.getElementById(id);
        if (!x) {
            return -1;
        }
        if (window.getComputedStyle(x).getPropertyValue("display") === "none") {
            ReactDOM.findDOMNode(x).style.setProperty("display", "block");         
            return true;
        } else {
            ReactDOM.findDOMNode(x).style.setProperty("display", "none");           
            return false;
        }
    } else {
        return -1;
    }
};

export const visibleLoad = async (id) => {
    if (id) {
        var x = document.getElementById(id);
        if (!x) {
            return -1;
        }
        if (window.getComputedStyle(x).getPropertyValue("display") === "none") {
            ReactDOM.findDOMNode(x).style.setProperty("display", "inline-block");         
            return true;
        } else {
            ReactDOM.findDOMNode(x).style.setProperty("display", "none");           
            return false;
        }
    } else {
        return -1;
    }
};

export const visibleToggle = async (id) => {
    if (id) {
        var x = document.getElementById(id);
        if (!x) {
            return -1;
        }
        if (window.getComputedStyle(x).getPropertyValue("display") === "none") {
            ReactDOM.findDOMNode(x).style.setProperty("display", "inline-block");         
            return true;
        } else {
            ReactDOM.findDOMNode(x).style.setProperty("display", "none");           
            return false;
        }
    } else {
        return -1;
    }
};

export const toggleEyes = (ids, e) =>{
    ids.forEach(id => {
        var element = document.getElementById(id);
        if(element.type === "password"){
            element.type = "text";
        }else{
            element.type = "password";
        }
    });
    if(e){
        return eye;
    }else{
        return eyeClosed;
    }
};

export const Porcentagem = (percent, total) => {
    return ((percent/ 100) * total)
};

export const MaskReal = (valor, percent) => {
    if(valor !== 0){
        if(valor === '1'){
            valor = "R$ 0,001"
        }else if(valor === '2'){
            valor = "R$ 0,002"
        }else if(valor === '3'){
            valor = "R$ 0,003"
        }else if(valor === '4'){
            valor = "R$ 0,004"
        }else if(valor === '5'){
            valor = "R$ 0,005"
        }else if(valor === '6'){
            valor = "R$ 0,006"
        }else if(valor === '7'){
            valor = "R$ 0,007"
        }else if(valor === '8'){
            valor = "R$ 0,008"
        }else if(valor === '9'){
            valor = "R$ 0,009"
        }
        
        valor = valor.replace("R$ ","");
        valor = valor.replace(".","");
        valor = valor.replace(",",".");
        valor = valor * percent;
        valor = Number.parseFloat(valor).toFixed(2);
        valor = parseFloat(valor); 
    }   
    return valor;     
};

export const isValidCPF = (cpf) => {
    if (typeof cpf !== 'string') return false
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
    cpf = cpf.split('')
    const validator = cpf
        .filter((digit, index, array) => index >= array.length - 2 && digit)
        .map( el => +el )
    const toValidate = pop => cpf
        .filter((digit, index, array) => index < array.length - pop && digit)
        .map(el => +el)
    const rest = (count, pop) => (toValidate(pop)
        .reduce((soma, el, i) => soma + el * (count - i), 0) * 10) % 11 % 10
    return !(rest(10,2) !== validator[0] || rest(11,1) !== validator[1])
};

export function toMilhar(s, func) {
    //func === null ---> resposta padrão
    //func === 1 ---> moeda
    let ss = 0;
  
    if (s !== undefined) {
      if (func === 1) {
        ss = s.toFixed(2).toString().replace(".", ",");
        ss = ss.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        ss = s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    }
    return ss;
};

export function formatarMilharDecimal(s, func) {
    if (!s) return ""; // Evita erro com valores indefinidos

    let num = parseFloat(s.replace(/\./g, "").replace(",", ".")); // Converte corretamente para número
  
    if (isNaN(num)) return ""; // Retorna vazio se não for um número válido
  
    if (func === 1) {
      return num.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
    } else {
      return num.toLocaleString("pt-BR");
    }
}

export function formatCnpjCpf(value) {
    const cnpjCpf = value.replace(/\D/g, "");
  
    if (cnpjCpf.length === 18) {
      // eslint-disable-next-line no-useless-escape
      return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    }
    // eslint-disable-next-line no-useless-escape
    return cnpjCpf.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
      "$1.$2.$3/$4-$5"
    );
}

export function MascaraCPNJCPF(value) {
    value = value.replace(/\D/g, "");    
    if (value.length === 11) {
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (value.length === 14) {
        return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }    
    return value;
}

export function limpaCnpjCpf(value){
    let cnpjCpf = value.replace(/\D/g, '');    
    if (cnpjCpf.length === 14){
        cnpjCpf = cnpjCpf.replace(/[.]/g, '');
        cnpjCpf = cnpjCpf.replace('-', ''); 
       
    }else{
        cnpjCpf = cnpjCpf.replace(" ", "");
        cnpjCpf = cnpjCpf.replace(".", "");
        cnpjCpf = cnpjCpf.replace(".", "");
        cnpjCpf = cnpjCpf.replace("/", "");
        cnpjCpf = cnpjCpf.replace("-", "");
    }
    return cnpjCpf; 
};

export const numberToReal = number => {
    let v = number.replace(/\D/g, ""); 
    v = (v / 100).toFixed(2) + "";	
    v = v.replace(".", ",");
    v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
    v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
    return v;  
};

export const realToNumber = numberString => { 
    //numberString = numberString.replace(",",".");
    return numberString
    
	//return parseFloat(numberString.replace(/\./g, '').replace('R$ ', '.').replace(',', '.')).toFixed(2);
};

export const limpaCampoValor = async (id) => {
    let input = document.getElementById(id);         
    input.addEventListener('keydown', function(event) {
      const key = event.key;
      if (key === "Backspace") {            
        document.getElementById(id).value = "0";
      } 
    });
};

export const ajustaDate = (value) => {
    let data = value;
    data = data.split("/").reverse().join("-");
    data = data+"T00:00:00";
    return data;
};

export const DateFormat = (value) => {
    let data = value;
    data = data.split("-").reverse().join("/");
    data = data
    return data;
};

//ainda nao utilizo
export const dataHora = (value) => { 
    
    let dataFull = value;
    let data = ""
    let hora = ""
    dataFull = dataFull.split("T")
    hora =  dataFull[1]   
    hora = hora.split(".") 
    hora = hora[0]
    data = dataFull[0]
    data = data.split("-").reverse().join("/");
    return data + " - " + hora;
};

export const  validaDate = async (data) => {
    let dia = data.split("/")[0];
    let mes = data.split("/")[1];
    let ano = data.split("/")[2];   
    let Year = new Date().getFullYear();
    if((mes > 12)||(dia > 31)||(ano > Year)) return false;
    
    return true;       
   
};

export const DataHoraFormatada = (Data) => {
    var data = new Date(Data);
    var dia  = data.getDate().toString();
    var diaF = (dia.length == 1) ? '0'+dia : dia;
    var mes  = (data.getMonth()+1).toString();
    var mesF = (mes.length == 1) ? '0'+mes : mes;
    var anoF = data.getFullYear();
    var hora = data.getHours();
    var horaF = hora < 10 ? '0'+hora : hora;
    var min = data.getMinutes();
    var minF = min < 10 ? '0'+min : min;
    return diaF +"/"+ mesF +"/"+ anoF + " - " + horaF + ":" +minF;
}

export const formatarDataHorasString = (dataISO) => {
  const data = new Date(dataISO);

  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0'); // mês começa do zero
  const ano = data.getFullYear();

  const horas = String(data.getHours()).padStart(2, '0');
  const minutos = String(data.getMinutes()).padStart(2, '0');

  return `${dia}/${mes}/${ano} às ${horas}:${minutos}`;
}

export const MudaVisibilidade = async (id, barra = true) => {
  if (id) {
    var x = document.getElementById(id);
    if (!x) {
      return -1;
    }

    if (window.getComputedStyle(x).getPropertyValue("display") === "none") {
      ReactDOM.findDOMNode(x).style.setProperty("display", "block");
      if (barra) {
        document.body.classList.remove("overyea");
        document.body.classList.add("overnot");
      }
      return true;
    } else {
      ReactDOM.findDOMNode(x).style.setProperty("display", "none");
      if (barra) {
        document.body.classList.remove("overnot");
        document.body.classList.add("overyea");
      }
      return false;
    }
  } else {
    return -1;
  }
};

export function EncrypteValue(text) {
    var keyS = "K7z8f5evI72H6QPvf82GvYvm27YgD934";
    var key = aesjs.utils.utf8.toBytes(keyS);
  
    var ivS = "0123456789abcdef";
    var iv = aesjs.utils.utf8.toBytes(ivS);
    var textBytes = aesjs.utils.utf8.toBytes(text);
    textBytes = aesjs.padding.pkcs7.pad(textBytes);
  
    var aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
    var encryptedBytes = aesCbc.encrypt(textBytes);
  
    // To print or store the binary data, you may convert it to hex
    var encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
  
    return encryptedHex;
}

export function formataDataComUltimoDiaMes(dataSelecionada) {
    const [year, month] = dataSelecionada.split('-');
    const ultimoDiaMes = new Date(year, month, 0).getDate();
    const formattedDate = `${year}-${month}-${String(ultimoDiaMes).padStart(2, '0')}`;

    return formattedDate
};

export function formatarData(dataISO) {
    const data = new Date(dataISO);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    
    return `${dia}/${mes}/${ano}`;
}


export function DateFormatTNew(value) {
    let data = value;
   // console.log("🚀 ~ DateFormatTNew ~ data:", data)
    if(data !== null){
        data = data.split("T")
        data = data[0] 
        data = data.split("-").reverse().join("/");       
        return data;
    }
  
};

export function mascaraCPF(cpf) {
    // Remove qualquer caractere que não seja número
    cpf = cpf.replace(/\D/g, '');
  
    // Aplica a máscara: 000.000.000-00
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  
    return cpf;
}

export const DimensoesPagina = () => {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  function getCurrentDimension(){
    return {
        width: window.innerWidth,
        height: window.innerHeight
    }
  }

  useEffect(() => {
      const updateDimension = () => {
          setScreenSize(getCurrentDimension())
      }
      window.addEventListener('resize', updateDimension);  
  
      return(() => {
          window.removeEventListener('resize', updateDimension);
      })
  }, [screenSize])

  return screenSize;
}  

export function FormatarParaReal(valor) {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(valor);
}

export const formaNumeroBr = (valor) => {
    if(!valor){
      return '-';
    }

    const valorFormado = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(valor);

    return valorFormado;
}

export const validaCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false; // Elimina CPFs com todos os dígitos iguais ou diferente de 11 dígitos
  }

  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) {
    return false;
  }

  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(10))) {
    return false;
  }

  return true;
}

export  const validarCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs com todos os dígitos iguais
  if (/^(\d)\1+$/.test(cnpj)) return false;

  const calcularDigito = (cnpjParcial, pesos) => {
    const soma = cnpjParcial
      .split('')
      .reduce((total, num, i) => total + Number(num) * pesos[i], 0);

    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const pesosPrimeiroDigito = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesosSegundoDigito  = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const base = cnpj.slice(0, 12);
  const digito1 = calcularDigito(base, pesosPrimeiroDigito);
  const digito2 = calcularDigito(base + digito1, pesosSegundoDigito);

  return cnpj.endsWith(`${digito1}${digito2}`);
}

export var dateAdjustment = (d, h) => {
  if (d) {
    var fragmented = d.split("T");
    var date = fragmented[0].split("-");
    date = date.reverse().join("/");
    if (!h) {
      return date;
    }
    date = date + " - " + fragmented[1].replace(/(\:\d*$)|(\:\d*\.\d*$)/g, "");
    return date;
  } else {
    return -1;
  }
};

export function Milhar(s, func) {
  //func === null ---> resposta padrão
  //func === 1 ---> moeda
  let ss = 0;

  if (s !== undefined && s !== null) {
    if (func === 1) {
      ss = s.toFixed(2).toString().replace(".", ",");
      ss = ss.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    } else {
      ss = s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  } else {
    return ss;
  }
  return ss;
}